var $, old;

$ = window.jQuery;

old = $.fn.onTransitionEnd;


/*
Call `callback` after CSS transitions finish. If CSS transitions are not
supported, the `callback` is called immediately. Idea based on:
http://blog.teamtreehouse.com/using-jquery-to-detect-when-css3-animations-and-transitions-end

    $('#animating').onTransitionEnd(function() {
      alert('done!');
    });
 */

$.fn.onTransitionEnd = function(callback) {
  if (Modernizr.csstransitions) {
    jQuery(this).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', callback);
    return this;
  } else {
    return this.each(function() {
      return callback.apply(this);
    });
  }
};

$.fn.onTransitionEnd.noConflict = function() {
  $.fn.onTransitionEnd = old;
  return this;
};
